import React, { useEffect, useState } from 'react';
import CheckBox from '../../../../Shared/CheckBox/Checkbox';
import { buildUrlAndOpenWindow } from '../../../../../utilities/StringHelpers/StringHelpers';
import ThirdParty from '../../../../Shared/ThirdParty/ThirdParty';

const UserAddress = (props) => {

  const [userAddress, setUserAddress] = useState({
    isSelectedAddress: { value: false, error: '' },
    // isReceivingBill: { value: props.isDisplayCheckboxIsReceivingBill },
    // isReceivingAd: { value: false },
    // isConfirmTerms: { value: false, error: '' },
  });

  useEffect(() => {

    if(!props.isDisplaySeparateInvoice && props.userAddress?.length == 1){
      handleSelectAddress({ address: props.userAddress[0], isSelectedSeparateInvoice: false });
    }

   }, []);

  useEffect(() => {
    if (props.onSubmit) {
      const validation = isValid();
      const data = {
        isValid: validation,
        // isReceivingBill: userAddress.isReceivingBill.value,
        // isReceivingAd: userAddress.isReceivingAd.value
      };
      props.onValid(data);
    }
  }, [props.onSubmit]);


  function isValid() {
    let isValid = true;

    if (!userAddress.isSelectedAddress.value) {
      isValid = false;
      userAddress.isSelectedAddress.error = 'אנא בחר אחת מן מהאפשרויות';
      setUserAddress({ ...userAddress });
    }

    // if (!userAddress.isConfirmTerms.value) {
    //   isValid = false;
    //   userAddress.isConfirmTerms.error = 'אנא אשרו את תנאי ההסכם';
    //   setUserAddress({ ...userAddress });
    // }
    return isValid;
  };


  const paymentDetails = (address) => {
    let paymentText = '';
    if (address.additionalInfo.paymentType == 'CREDIT_CARD') {
      paymentText = 'החיוב ירד מאמצעי התשלום בו מחוייב חשבונך';
    } else if (address.additionalInfo.paymentType == 'BANK') {
      paymentText = 'החיוב ירד מחשבון הבנק בו מחוייב חשבונך';
    } else if (address.additionalInfo.paymentType == 'PAYPAL') {
      paymentText = 'החיוב ירד מחשבון ה-PayPal בו מחוייב חשבונך';
    }
    if (paymentText && address.additionalInfo.paymentToken) {
      return (
        <div className='payment-details'>
          <div className='payment-text'>{paymentText}</div>
          <div className='payment-token' dir='ltr'>
            {address.additionalInfo.paymentToken}
          </div>
        </div>
      );
    }
    return null;
  };

  const billingAddress = (address) => {
    let prefixText = '';
    if (address.additionalInfo.billingAddressType == 'SMS') {
      prefixText = 'טלפון : ';
    } else if (address.additionalInfo.billingAddressType == 'EMAIL') {
      prefixText = 'מייל : ';
    }
    else if (address.additionalInfo.billingAddressType == 'ADDRESS') {
      prefixText = 'כתובת : ';
    }
    if (prefixText) {
      return (
        <div className='address'>החשבונית נשלחת ל{prefixText}{address.additionalInfo.billingAddress}</div>
      );
    }
    return null;
  }

  return (
    <div className='user-address' data-count={props.userAddress?.length}>
      {props.userAddress?.map((address, index) => {
        return (
          <div
            key={index}
            data-banID={address.additionalInfo?.banId}
            onClick={() => handleSelectAddress({ address: address, isSelectedSeparateInvoice: false })}
            className={`address-wrapper ${props.selectedAddress?.additionalInfo?.banId == address.additionalInfo?.banId ? 'active' : ''}`}>
            <div className='product-description'>פרטי חשבונית: {address.additionalInfo.productDescription.shortDescription}</div>
            {billingAddress(address)}
            {paymentDetails(address)}
          </div>
        );
      })}
      {props.isDisplaySeparateInvoice &&
         <div
         onClick={() => handleSelectAddress({ address: {}, isSelectedSeparateInvoice: true })}
         className={`address-wrapper new-address ${props?.isSelectedSeparateInvoice ? 'active' : ''}`}>
         רוצה חשבונית ניפרדת
       </div>
      }


      {userAddress.isSelectedAddress.error && <div className='error'>{userAddress.isSelectedAddress.error}</div>}

      {/* <div className='checkbox-wrapper'>

        <div className='row-wrapper'>
          <CheckBox
            id='terms-checkbox'
            onCheck={() => onCheck('isConfirmTerms')}
            onUncheck={() => onUncheck('isConfirmTerms')}
            onChange={() => handleOnConfirmTerms(!userAddress.isConfirmTerms.value)}
            checked={userAddress.isConfirmTerms.value}
            label={<> קראתי ואני מסכים <a href='#' onClick={() => buildUrlAndOpenWindow(props.programDetailsLink)}>לעיקרי פרטי התכנית</a>, <a href='#' onClick={() => buildUrlAndOpenWindow(props.connectionAgreementLink)}>להסכם ההתקשרות</a> <a href='#' onClick={() => buildUrlAndOpenWindow(props.generalTermsAgreementLink)}>ולתנאים הכלליים</a> </>}
          />
          {userAddress.isConfirmTerms.error && <div className='error'>{userAddress.isConfirmTerms.error}</div>}
        </div>

        {
          props.isDisplayCheckboxIsReceivingBill &&
          <div className='row-wrapper'>
            <CheckBox
              checked={userAddress.isReceivingBill.value}
              label='אני רוצה לקבל את החשבונית למייל שהזנתי (במקרה בו תסיר את הסימון, תשלח החשבונית לכתובת המגורים שמילאת)'
              id='isReceivingBill'
              onCheck={() => onCheck('isReceivingBill')}
              onUncheck={() => onUncheck('isReceivingBill')} />
          </div>
        }

        {
          props.isDisplayCheckboxReceivingAd &&
          <div className='row-wrapper'>
            <CheckBox
              checked={userAddress.isReceivingAd.value}
              label= {<ThirdParty/>}
              // label={<> אני מאשר/ת קבלת דברי פרסומת מסלקום ושותפיה העסקיים, ושיתוף מידע כמפורט להלן (גם אם לא תסמן, נשלח פרסומות לשירותינו בלבד, אלא אם ביקשת הסרה) <a href='#' onClick={() => buildUrlAndOpenWindow(props.advertisingInfoLink)}>המשך</a> </>}
              id='isReceivingAd'
              onCheck={() => onCheck('isReceivingAd')}
              onUncheck={() => onUncheck('isReceivingAd')} />
          </div>
        }

      </div> */}

    </div>
  );


  function handleSelectAddress(data) {
    userAddress['isSelectedAddress'] = { value: true, error: '' };
    setUserAddress({ ...userAddress });
    props.onSelectedAddress(data);
  }

  function onCheck(checkboxName) {
    userAddress[checkboxName].value = true;
    setUserAddress({ ...userAddress });
  }

  function onUncheck(checkboxName) {
    userAddress[checkboxName].value = false;
    setUserAddress({ ...userAddress });
  }

  // function handleOnConfirmTerms(value) {
  //   userAddress['isConfirmTerms'] = { value: value, error: (!value ? 'אנא אשרו את תנאי ההסכם' : '') };
  //   setUserAddress({ ...userAddress });
  // }

  // function openTermsInNewTab(e) {
  //   e.preventDefault();
  //   window.open(props.termsLink, '_blank').focus();
  // }

};

export default UserAddress;
